import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Crystalogram from './Crystalogram';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    { question: t('faq.question1'), answer: t('faq.answer1') },
    { question: t('faq.question2'), answer: t('faq.answer2') },
    { question: t('faq.question3'), answer: t('faq.answer3') },
    { question: t('faq.question4'), answer: t('faq.answer4') },
    { question: t('faq.question5'), answer: t('faq.answer5') },
    { question: t('faq.question6'), answer: t('faq.answer6') },
    { question: t('faq.question7'), answer: t('faq.answer7') },
    { question: t('faq.question8'), answer: t('faq.answer8') },
    { question: t('faq.question9'), answer: t('faq.answer9') },
    { question: t('faq.question10'), answer: t('faq.answer10') },
    { question: t('faq.question11'), answer: t('faq.answer11') },
  ];

  return (
    <div className="text-white">
      <div className="faq-container mt-4 md:mt-8 space-y-4">
        {faqItems.map((item, index) => (
          <div key={index} className="faq-item bg-transparent border border-white border-opacity-20 rounded-lg p-3 md:p-4">
            <h3
              className="text-lg md:text-xl font-semibold cursor-pointer flex justify-between items-center text-white"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              {item.question}
              <span className="text-xl md:text-2xl text-white">{openIndex === index ? '−' : '+'}</span>
            </h3>
            {openIndex === index && (
              <p className="mt-3 md:mt-4 text-sm md:text-base text-white">{item.answer}</p>
            )}
          </div>
        ))}
      </div>
      <div className="divider my-4"></div>
      <div className="faq-item bg-transparent border border-white border-opacity-20 rounded-lg p-3 md:p-4">
        <h3
          className="text-lg md:text-xl font-semibold cursor-pointer flex justify-between items-center text-white"
          onClick={() => setOpenIndex(openIndex === 'crystalogram' ? null : 'crystalogram')}
        >
          {t('faq.crystalogramQuestion')}
          <span className="text-xl md:text-2xl text-white">{openIndex === 'crystalogram' ? '−' : '+'}</span>
        </h3>
        {openIndex === 'crystalogram' && (
          <div className="mt-3 md:mt-4 text-sm md:text-base text-white">
            <p className="mb-4">{t('faq.crystalogramDescription')}</p>
            <Crystalogram />
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;